import React from "react";
import Selector from "./Selector";
import { formatClientOptions } from "./helpers";

const ClientSelector = ({ clients, value, setParentState, isLoading }) => {
  const handleUpdateClientValue = (val) => {
    const clientId = value;
    if (val == null) {
      setParentState({
        clientId: null,
        medId: null,
        medications: [],
      });
    } else if (clientId && val.value != clientId.value) {
      setParentState({
        clientId: val,
        medId: null,
        medications: [],
      });
    } else {
      setParentState({
        clientId: val,
        medications: [],
      });
    }
    fetchMedications(val.value);
  };

  const fetchMedications = async (residentId) => {
    setParentState({ medicationsIsLoading: true });
    $.ajax({
      url: `/api/staff/v1/residents/${residentId}/medications_for_medication_log.json`,
      method: "GET",
      success: (data) => {
        setParentState({ medicationsIsLoading: false });
        setParentState({
          medications: data,
        });
      }
    });
  };

  return (
    <Selector
      value={value}
      isLoading={isLoading}
      placeholder="Select a Client..."
      onUpdateValue={(value) => handleUpdateClientValue(value)}
      options={formatClientOptions(clients)}
    />
  );
};

export default ClientSelector;
